import { TestimonialPrizeTypeLabel } from 'common/enums/TestimonialEnum'
import { Separator } from 'components/Separator/Separator'

import { Text } from '@interco/inter-ui/components/Text'

import { ITestimonial } from './TestimonialsCarousel.types'
import * as S from './TestimonialsCarousel.styles'

interface TestimonialProps {
  testimonial: ITestimonial
}

export const Testimonial = ({ testimonial }: TestimonialProps) => (
  <S.TestimonialCard>
    <Text variant="caption-1" colorWeight={400}>
      {TestimonialPrizeTypeLabel[testimonial.prizeType]}
    </Text>
    <Text variant="body-3" colorWeight={600} bold>
      {testimonial.prize}
    </Text>

    {testimonial.testimonial && (
      <Text variant="caption-1" as="p" colorWeight={400}>
        {testimonial.testimonial}
      </Text>
    )}

    <Separator borderWidth="1px" margin="16px 0" color="var(--primary200)" />

    <Text variant="caption-1" colorWeight={600} bold>
      {testimonial.winner}
    </Text>
    <Text variant="caption-1" colorWeight={400}>
      {testimonial.city}
    </Text>
  </S.TestimonialCard>
)
